import axios from "axios";

// const BASE_URL = "https://gidexstage.ginox.io/api/v1/admin";
const BASE_URL = process.env.REACT_APP_GINOX_AI_API_URL;
const ADMIN_KEY = process.env.REACT_APP_OMNISERVE_KEY;

const headers = { "x-admin-key": ADMIN_KEY };

export const getAIStatus = (refresh = false) => {
  const url = refresh
    ? `${BASE_URL}/ai/status?refresh=true`
    : `${BASE_URL}/ai/status`;
  return axios.get(url, { headers });
};

export const getPaymentConfig = () => {
  return axios.get(`${BASE_URL}/payments/config`, { headers });
};

export const updatePaymentConfig = (recipientAddress) => {
  return axios.put(
    `${BASE_URL}/payments/config`,
    { recipientAddress },
    { headers }
  );
};

export const getPaymentPackages = () => {
  return axios.get(`${BASE_URL}/payments/packages`, { headers });
};

export const createPaymentPackage = (packageData) => {
  return axios.post(`${BASE_URL}/payments/packages`, packageData, { headers });
};

export const updatePaymentPackage = (id, packageData) => {
  return axios.put(`${BASE_URL}/payments/packages/${id}`, packageData, {
    headers,
  });
};

export const deletePaymentPackage = (id) => {
  return axios.delete(`${BASE_URL}/payments/packages/${id}`, { headers });
};

export const restorePaymentPackage = (id) => {
  return axios.put(
    `${BASE_URL}/payments/packages/${id}/restore`,
    {},
    { headers }
  );
};

export const getWebhookSyncStatus = () => {
  return axios.get(`${BASE_URL}/payments/config/webhooks`, { headers });
};
